module.exports = __webpack_public_path__ + "static/media/exploreBanner.5479d019.webp";